import Typography from '@mui/material/Typography';
import { RichTextComponent, isElement } from '../utils';

export const Paragraph: RichTextComponent = (node, children) =>
  isElement(node) && node.name === 'p' ? (
    <Typography {...node.attribs}>{children}</Typography>
  ) : null;
